import React, { useEffect } from 'react'
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Typography, CircularProgress } from '@mui/material'
import { useDispatch, useSelector } from 'react-redux'
import { RootState, AppDispatch } from 'src/store'
import { fetchCompanies } from 'src/features/companiesSlice'
import { useTranslation } from 'react-i18next'

const CompanyTable = () => {
  const { t } = useTranslation()
  const dispatch = useDispatch<AppDispatch>()
  const { companies, loading, error } = useSelector((state: RootState) => state.companies)
  const { token } = useSelector((state: RootState) => state.auth)

  useEffect(() => {
    if (!token) return
    dispatch(fetchCompanies())
  }, [dispatch, token])

  if (loading) return <CircularProgress />
  if (error) return <Typography color="error">{error}</Typography>
  if (companies.length === 0) return <Typography>{t("companyTable.noCompanies")}</Typography>

  return (
    <TableContainer component={Paper}>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>{t("companyTable.name")}</TableCell>
            <TableCell>{t("companyTable.website")}</TableCell>
            <TableCell>{t("companyTable.industry")}</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {companies.map((company) => (
            <TableRow key={company.id} hover>
              <TableCell>{company.name}</TableCell>
              <TableCell>{company.website}</TableCell>
              <TableCell>{company.industry || '-'}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  )
}

export default CompanyTable
